import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import WKTWriter from '../../io/WKTWriter';
import Coordinate from '../../geom/Coordinate';
import IntervalRTreeLeafNode from './IntervalRTreeLeafNode';
import IntervalRTreeNode from './IntervalRTreeNode';
import Collections from '../../../../../java/util/Collections';
import System from '../../../../../java/lang/System';
import ArrayList from '../../../../../java/util/ArrayList';
import IntervalRTreeBranchNode from './IntervalRTreeBranchNode';
var SortedPackedIntervalRTree = /*#__PURE__*/function () {
  function SortedPackedIntervalRTree() {
    _classCallCheck(this, SortedPackedIntervalRTree);
    SortedPackedIntervalRTree.constructor_.apply(this, arguments);
  }
  _createClass(SortedPackedIntervalRTree, [{
    key: "buildTree",
    value: function buildTree() {
      Collections.sort(this._leaves, new IntervalRTreeNode.NodeComparator());
      var src = this._leaves;
      var temp = null;
      var dest = new ArrayList();
      while (true) {
        this.buildLevel(src, dest);
        if (dest.size() === 1) return dest.get(0);
        temp = src;
        src = dest;
        dest = temp;
      }
    }
  }, {
    key: "insert",
    value: function insert(min, max, item) {
      if (this._root !== null) throw new IllegalStateException('Index cannot be added to once it has been queried');
      this._leaves.add(new IntervalRTreeLeafNode(min, max, item));
    }
  }, {
    key: "query",
    value: function query(min, max, visitor) {
      this.init();
      if (this._root === null) return null;
      this._root.query(min, max, visitor);
    }
  }, {
    key: "buildRoot",
    value: function buildRoot() {
      if (this._root !== null) return null;
      this._root = this.buildTree();
    }
  }, {
    key: "printNode",
    value: function printNode(node) {
      System.out.println(WKTWriter.toLineString(new Coordinate(node._min, this._level), new Coordinate(node._max, this._level)));
    }
  }, {
    key: "init",
    value: function init() {
      if (this._root !== null) return null;
      if (this._leaves.size() === 0) return null;
      this.buildRoot();
    }
  }, {
    key: "buildLevel",
    value: function buildLevel(src, dest) {
      this._level++;
      dest.clear();
      for (var i = 0; i < src.size(); i += 2) {
        var n1 = src.get(i);
        var n2 = i + 1 < src.size() ? src.get(i) : null;
        if (n2 === null) {
          dest.add(n1);
        } else {
          var node = new IntervalRTreeBranchNode(src.get(i), src.get(i + 1));
          dest.add(node);
        }
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._leaves = new ArrayList();
      this._root = null;
      this._level = 0;
    }
  }]);
  return SortedPackedIntervalRTree;
}();
export { SortedPackedIntervalRTree as default };